/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* delivery times object for loading unit
*/
export class DeliveryTimes {
    'plannedTrainDeparture': Date;
    'latestLoadingTime': Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "plannedTrainDeparture",
            "baseName": "plannedTrainDeparture",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "latestLoadingTime",
            "baseName": "latestLoadingTime",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return DeliveryTimes.attributeTypeMap;
    }

    public constructor() {
    }
}

